import { Component, OnInit } from "@angular/core";
import {
  FormBuilder, FormControl, FormGroup,
  Validators
} from "@angular/forms";
import { Router } from "@angular/router";
import { CustomValidators } from "ng2-validation";

const password = new FormControl("", Validators.required);
const confirmPassword = new FormControl("", CustomValidators.equalTo(password));

@Component({
  selector: "app-signup",
  templateUrl: "./signup.component.html",
  styleUrls: ["./signup.component.scss"],
})
export class SignupComponent implements OnInit {
  public form: FormGroup;
  constructor(private fb: FormBuilder, private router: Router) {}

  ngOnInit() {
    this.form = this.fb.group({
      uname: [null, Validators.compose([Validators.required])],
      password: password,
      confirmPassword: confirmPassword,
    });
  }

  onSubmit() {
    this.router.navigate(["/"]);
  }
}
